<template>
	<div class="col-12 col-md-5 col-lg-4">
		<div v-if="item.sub_items.length > 1" class="announce_image_block">
			<div v-swiper:menuSwiper="options">
				<div class="swiper-wrapper">
					<div
						v-for="(sub_item, index_subitem) in item.sub_items"
						:key="index_subitem"
						ref="swipers"
						class="swiper-slide"
					>
						<b-img-lazy v-if="sub_item.image" :src="sub_item.image" :alt="index_subitem" />
					</div>
				</div>

				<div class="swiper-navigation">
					<div :id="prevElId" class="btn btn-outline-primary icon-arrow_prev" />
					<div :id="nextElId" class="btn btn-outline-primary icon-arrow_next" />
				</div>
			</div>
		</div>

		<div v-if="item.sub_items.length === 1" class="announce_image_block">
			<b-img-lazy :src="item.sub_items[0].image" alt="" />
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { BImgLazy } from 'bootstrap-vue';

export default {
	name: 'PanelLi01Image',
	components: {
		Swiper,
		SwiperSlide,
		BImgLazy,
	},
	directives: {
		swiper: directive,
	},
	props: ['blockId', 'item', 'index'],
	data() {
		return {
			options: {
				slidesPerView: 1,
				spaceBetween: 0,
				// cssMode: false,
				// freeMode: true,
				loop: true,

				navigation: {
					prevEl: `#swiper-timeline-prev_${this.blockId}_${this.index}`,
					nextEl: `#swiper-timeline-next_${this.blockId}_${this.index}`,
					disabledClass: 'disabled',
				},
			},
		};
	},
	computed: {
		prevElId() {
			return this.options.navigation.prevEl.slice(1);
		},
		nextElId() {
			return this.options.navigation.nextEl.slice(1);
		},
	},

};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/short-announce-list";
</style>
